@if (contenuPromo(); as contenuPromo) {
  <section class="pt-7">
    <div class="mask-curve-top bg-gray-light py-9">
      <div class="centered-with-padding grid grid-cols-1 gap-x-9 gap-y-6 desk:grid-cols-2">
        <app-image
          [image]="contenuPromo.image"
          [isPriority]="!isImageInPreviousBlocks"
          [pregenerationSize]="{ width: 1280 }"
          [keepAspectRatio]="true"
          customClass="rounded-xl" />
        <div class="flex flex-col gap-y-4">
          @if (contenuPromo.title; as title) {
            <app-title [title]="title" size="h2" />
          }
          @if (contenuPromo.text; as text) {
            <div [innerHtml]="text" handleHtmlLinks></div>
          }
          <div class="py-1.5">
            @if (contenuPromo.cta; as cta) {
              @let gtm = contenuPromo.gtmConfigCta;
              <app-button
                (onButtonClick)="
                  emitGtmEvent({
                    event: gtm?.event,
                    group: gtm?.group,
                    description: gtm?.description,
                    context: gtm?.context,
                    button_text_value: cta.label,
                    event_type: 'click',
                  })
                "
                [label]="cta.label"
                [url]="cta.url" />
            }
          </div>
          @if (contenuPromo.conditions; as conditions) {
            <div [innerHTML]="conditions" class="prose prose-sm text-sm font-medium" handleHtmlLinks></div>
          }
        </div>
      </div>
    </div>
  </section>
}
